import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useAuthStore = defineStore('auth', () => {
	const previousRoute = ref<string>()

	const getPreviousRoute = () => {
		return previousRoute.value
	}

	const setPreviousRoute = (route: string) => {
		previousRoute.value = route
	}

	const resetPreviousRoute = () => {
		previousRoute.value = undefined
	}
	return {
		getPreviousRoute,
		setPreviousRoute,
		resetPreviousRoute,
	}
})
